import { useEffect, useState } from 'react';
import { updateRecalculateRequiredWidgetHeight } from '../../Lib/redux/slices/dynamicHeight';
import { setWidgetHeightOverrides } from '../../Helpers/dynamicHeight';

export const DATE_PICKER_MODAL_HEIGHT = 334;
const CLOSING_DELAY_BEFORE_HEIGHT_ADJUSTMENT = 500;

const useDatePickerHeightManagement = (containerRef, dispatch, id) => {
  const [showModalTimeoutId, setShowModalTimeoutId] = useState();
  const overrideKey = `datePickerModal-${id}`;

  const handleShowModalHeightAdjustment = ({ isModalVisible }) => {
    const containerElement = containerRef.current;
    const modalOverrideHeight =
      isModalVisible && containerElement
        ? containerElement.offsetHeight +
          containerElement.offsetTop +
          DATE_PICKER_MODAL_HEIGHT
        : undefined;
    clearTimeout(showModalTimeoutId);
    const timeoutId = setTimeout(
      () => {
        setWidgetHeightOverrides({
          [overrideKey]: modalOverrideHeight,
        });
        dispatch(
          updateRecalculateRequiredWidgetHeight({
            isWidgetHeightRecalculationRequired: true,
          })
        );
      },
      isModalVisible ? 0 : CLOSING_DELAY_BEFORE_HEIGHT_ADJUSTMENT
    );
    setShowModalTimeoutId(timeoutId);
  };

  // Cleanup effect for date picker modal height override
  useEffect(() => {
    return () => {
      setWidgetHeightOverrides({
        [overrideKey]: undefined,
      });
      clearTimeout(showModalTimeoutId);
    };
  }, []);

  return { handleShowModalHeightAdjustment };
};

export default useDatePickerHeightManagement;
